import React, { useContext, useEffect, useRef } from 'react';
import classNames from 'classnames';
import { Input } from '@fx-ui/fine-design';
import Intl from '@fx-ui/intl';
import { get, getReferrers, indexOf, isPersonaFieldAvailable, map } from '~/utils';
import PersonaContext from '../../context/persona';
import PersonaCollectItem from '../persona-collect-item';
import { isOtherTag } from '../../../../utils/register';

/**
 * 你从哪里了解到我们
 */
const Referrer = () => {
    const { personaInfo, setPersonaInfo, personaLabel } = useContext(PersonaContext);
    const { referrers, refererOtherVal } = personaInfo || {};

    const referInput = useRef<any>();

    useEffect(() => {
        if (isOtherTag(get(referrers, '0', ''))) {
            referInput.current.focus();
        }
    }, [referrers]);

    const changeRefer = (item: Record<string, any>) => {
        const idx = indexOf(referrers, item?.value);
        let arr = referrers?.slice() || [];
        if (idx > -1) {
            arr?.splice(idx, 1);
        } else {
            // 相当于点选【其他】标签后就变成了单选模式，此外则为多选模式
            if (isOtherTag(item.value)) {
                arr = [item.value];
            } else {
                isOtherTag(get(referrers, '0', '')) && arr?.shift();
                arr?.push(item.value);
            }
        }
        setPersonaInfo({
            referrers: arr
        });
    };

    if (!isPersonaFieldAvailable(personaLabel, 'referrer')) {
        return null;
    }

    return (
        <PersonaCollectItem className="fx-persona-referrer" title={Intl.get('persona.referrer')}>
            {map(getReferrers(personaLabel || []), (item) => (
                <div
                    key={item.value}
                    className={classNames('select-item', {
                        select: indexOf(referrers, item.value) > -1
                    })}
                    onClick={() => changeRefer(item)}
                >
                    <div className="item-info">{item.text}</div>
                </div>
            ))}
            {isOtherTag(get(referrers, '0', '')) && (
                <div className="refer-other">
                    <Input
                        ref={referInput}
                        className="refer-input"
                        type="text"
                        maxLength={20}
                        placeholder={Intl.get('persona.referrers.other.placeholder')}
                        value={refererOtherVal}
                        onChange={(v) =>
                            setPersonaInfo({
                                refererOtherVal: v
                            })
                        }
                    />
                </div>
            )}
        </PersonaCollectItem>
    );
};

export default Referrer;
